"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CityLabel = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'city-label';
class CityLabel extends react_1.default.PureComponent {
    render() {
        const { code, name, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            code && (react_1.default.createElement("div", { className: `${className}__code` }, code)),
            name && (react_1.default.createElement("div", { className: `${className}__name` }, name))));
    }
}
exports.CityLabel = CityLabel;
CityLabel.defaultProps = {
    code: null,
    name: null,
};
//# sourceMappingURL=index.js.map